function upsellsFunctionalities() {
  const selectUpsells = document.querySelectorAll(".product-form__input-upsell");
  const buttonAddCartUpsells = document.querySelectorAll(".ProductForm__AddToCart-upsells");
  const quantitySelector = document.querySelectorAll('.upsell-quantity')
  let selectedSize = null;
  let selectedColor = null;

  function combineColorSizeInfo(color, size) {
    return `${color} / ${size}`;
  }

  function changeSelect(info, productId) {
    const getSelect = document.getElementById(`product-select-${productId}`);
    if(getSelect.getAttribute("size-option")!== '') {
      for (const option of getSelect.options) {
        if (option.text === info) {
          getSelect.value = option.value;
          const changePrice = document.getElementById(`cart-upsells-compareprice-${productId}`)
          changePrice.textContent = `$${parseInt(option.getAttribute("price"))}`
          document.getElementById(`product-upsell-${productId}`).value = option.value
          break;
        }
      }
    } else {
      const color = info.split(' ')[0]
      for (const option of getSelect.options) {
        if (option.text === color) {
          getSelect.value = option.value;
          document.getElementById(`product-upsell-${productId}`).value = option.value
          break;
        }
      }
    }

    
  }

  const initialSelectedSize = document.querySelector(".product-form__input-upsell input[name='Size']:checked");
  const initialSelectedColor = document.querySelector(".product-form__input-upsell input[name='Color']:checked");

  if (initialSelectedSize) {
    selectedSize = initialSelectedSize.value;
  }

  if (initialSelectedColor) {
    selectedColor = initialSelectedColor.value;
  }

  selectUpsells.forEach(function (input) {

    if (input.getAttribute("name") === "Size") {
      selectedSize = input.value;
    } else if (input.getAttribute("name") === "Color") {
      selectedColor = input.value;
    }
    
    input.addEventListener("change", function (event) {
      const target = event.target;
      if (target.getAttribute("name") === "Size") {
        selectedSize = target.value;
      } else if (target.getAttribute("name") === "Color") {
        selectedColor = target.value;
      }
      const productId = target.getAttribute("data-product-id");
      document.getElementById(`form__label-color-name-upsell-${productId}`).textContent = selectedColor;
      const colorSizeInfo = combineColorSizeInfo(selectedColor, selectedSize);
      changeSelect(colorSizeInfo, productId);

      changeUpsellImage(target);

    });
  });

  function changeUpsellImage(e) {
    if (e.classList.contains('input_Color-upsell')) {
      let dataImage = e.dataset.image,
      imageUpsell = e.closest('.upsells-content').querySelector('img');
      imageUpsell.src = dataImage;
    }
  }

  buttonAddCartUpsells.forEach((button) => {
    button.addEventListener('click', (e) => {
      console.log('click')
      e.preventDefault();
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
      const selectedOption = document.querySelector(
        `select[data-product-id="${e.target.getAttribute("data-product-id")}"]`
      );
    })
  })

  quantitySelector.forEach((quantity) => {
    quantity.addEventListener('click', (event) => {
      const productId = event.target.getAttribute("data-product-id");
      const input = document.querySelector(`#quantity__input-${productId}`); 
      const inputValue = input.value;
    document.getElementById(`quantity-form-${productId}`).value = inputValue

    });
  });
}
    
  const upsellDrawer = () =>  {
    fetch('https://www.shopjoyby.com/collections/upsell/products.json')
    .then(function (response) {
      return response.json();
    }).then(function (collection) {
      fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) { 
        const filteredUpsell = collection.products.filter(upsellProduct => {
          return !cart.items.some(cartProduct => cartProduct.product_id === upsellProduct.id);

        });
        if (filteredUpsell.length === 0) {
          document.querySelector('.cart-upsells').style.display ="none";
        } else {
          document.querySelector('.cart-upsells').style.display ="block";
        }
        const getUpsellsDrawer = document.querySelector(".cart-upsells-contianer");
        getUpsellsDrawer.innerHTML = '';
        const createWrapper = document.createElement("div");
        createWrapper.classList.add("swiper-wrapper");
        getUpsellsDrawer.appendChild(createWrapper);
        for (const product of filteredUpsell) {
          const optionsHtml = product.options.map(option => {
            let optionsContent = '';
            let firstValue = '';
            optionsContent = `
            <div class="product-form__input-upsell">
              <div>
                ${option.values.map(value => {
                  if (!firstValue) {
                    firstValue = value;
                  }
                 
                  if (option.name === 'Color') { 

                    let imageUrl;

                    product.variants.forEach(variant => {
                      if(value == variant.option1 || value == variant.option2){
                          imageUrl = variant.featured_image.src;      
                      }
                    
                    });

                    return `
                      <input class="input_${option.name}-upsell" type="radio" id="upsell-${product.id}-${value}" name="${option.name}" value="${value}" ${value === option.values[0] ? 'checked' : ''} data-image="${imageUrl}"  data-product-id="${product.id}">
                      <label class="label_color-upsell ${value.toLowerCase().includes('white') ? ' borderColor' : ''}" style="background-color: ${value};" for="upsell-${product.id}-${value}" value="${value}"></label>
                    `;
                  }
                }).join('')}
                
                ${option.name !== 'Color' ? `
                    <div class="variant-dropdown-upsell">
                        <h4>${option.name}: </h4>
                        <select name="${option.name}" data-product-id="${product.id}">
                            <option value="default" selected>Select an option</option>
                            ${option.values.map(value => `<option>${value}</option>`).join('')}
                        </select>
                    </div>
                ` : ''}
              </div>
              
              ${option.name === 'Color' ? `
                <span id="form__label-color-name-upsell-${product.id}" class="form__label-color-name-upsell">${firstValue}</span>
              ` : ''}
            </div>
          `;
            return optionsContent;
          }).join('');
          const upsellsItem = document.createElement("div");
          upsellsItem.classList.add("card__product-upsells", "swiper-slide");
          let comparePrice;

          if (product.variants[0].compare_at_price != null) {
            comparePrice = product.variants[0].compare_at_price * 100;
          }else{
            comparePrice = "";
          }
          
          upsellsItem.innerHTML = `
            <div class="upsells-content">
              <a href="/products/${product.handle}">
              <img
              src="${product.images[0].src}"
              alt=""
              loading="lazy"
            >
            </a>
            <product-info id="ProductInfo-upsell" data-section="go-cart" data-url="/products/${product.handle}" class="product__info-container"><h2 class="cart-upsells-name">${product.title}</h2>
                <p class="cart-upsells-variant">${product.product_type}</p>
                <div class="upsell-price-contain">
                ${product.variants[0].compare_at_price ? `<p class="cart-upsells-compareprice" id="cart-upsells-compareprice-${product.id}">$${parseInt(product.variants[0].compare_at_price)}</p>` : ''}
                <p class="cart-upsells-price" id="cart-upsells-compareprice-${product.id}">$${parseInt(product.variants[0].price)}</p>
                </div>
                <div class="product-form__input-upsell">
                ${optionsHtml}
                <select id="product-select-${product.id}" name="id" title="Variant" class="visually-hidden" data-product-id="${product.id}">
                ${product.variants.map(variant => `
                  <option value="${variant.id}" price=${variant.price}>${variant.title}</option>
                `).join('')}
              </select>
                </div>
                <div>
                  <div class="button_quantity__product">
                    <div id="Quantity-Form-${product.id}" class="product-form__quantity">
                      <quantity-input class="quantity upsell-quantity" id="${product.id}-upsell-quantity">
                        <button class="quantity__button no-js-hidden disabled" name="minus" type="button" data-product-id="${product.id}">
                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
                          </path></svg>
                        </button>
                        <input class="quantity__input" type="number" name="quantity" id="quantity__input-${product.id}" data-min="1" min="1" step="1" value="1" form="product-form-${product.id}">
                        <button class="quantity__button no-js-hidden" name="plus" type="button" data-product-id="${product.id}">
                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
                          </path></svg>
                        </button>
                      </quantity-input>
                    </div>
                    <product-form class="product-form" data-hide-errors=""><form method="post" action="/cart/add" id="product-form-${product.id}" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id" id="product-upsell-${product.id}">
                      <input type="hidden" name="properties[_compare_price]" value="${comparePrice}"/>
                      <input type="hidden" name="quantity" value="1" id="quantity-form-${product.id}">
                      <div class="product-form__buttons">
                        <button id="ProductSubmitButton-upsell" type="submit" name="add" class="js-go-cart-add-to-cart js-go-cart-overlay product-form__submit button button--primary is-open">
                          <span>ADD
                          </span>
                          <div class="loading-overlay__spinner hidden">
                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                          </div>
                        </button>
                      </div></form></product-form>
                  </div>
                </div>
              </product-info>
            </div>
          `;
          createWrapper.appendChild(upsellsItem);
          new Swiper('.cart-upsells-contianer', {
            slidesPerView: 1,
            spaceBetween: 25,
            navigation: {
                nextEl: '.upsell-swiper-button-prev',
                prevEl: '.upsell-swiper-button-next',
              },
          });
        }
        upsellsFunctionalities()

      })
    })
  }